import * as pdfjs from 'pdfjs-dist/legacy/build/pdf';
import * as HtmlParsing from './HtmlParsing';
import {aiStore} from '../../index';
import {OPS} from 'pdfjs-dist/legacy/build/pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const MAX_CHUNK_LENGTH = 1500;

export async function parsePdf(file, isEmbedding, abortedFiles) {
    const arrayBuffer = await file.arrayBuffer();
    const loadingTask = pdfjs.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;

    let chunks = [];
    let allItems = [];
    let currentChunk = '';
    const pageCount = pdf.numPages;
    let images = `These are the images that are in though out this pdf, make sure you reference all of them their src in some nodes !!!!NodeMediaFilesRefs: `;

    for (let i = 1; i <= pageCount; i++) {
        if (handleAbort(file, abortedFiles, isEmbedding)) {
            return [];
        }
        const page = await pdf.getPage(i);

        const viewport = page.getViewport({ scale: 1 });
        const pageHeight = viewport.height;
        const pageWidth = viewport.width;

        const { lines: sortedLines, columnBoundary } = await getPageData(page, pageWidth);
        const tableDefs = await buildTableDefs(page, sortedLines);
        const tableLineSet = new Set();
        const tableStartMap = new Map();
        for (const def of tableDefs) {
            def.indices.forEach((idx, j) => {
                tableLineSet.add(idx);
                if (j === 0) tableStartMap.set(idx, def);
            });
        }

        currentChunk = `\n`;
        if (!isEmbedding) {
            const imageOps = await getPageImages(page);
            const imagesIdArray = await extractWithTimeout(page, imageOps.map(op => op.name), 2, file);
            aiStore.sendAiProgressLoaderValue(file.name, (i + 1) * 100 / (pageCount + 2));

            imagesIdArray.forEach(([returnedName, imageId], k) => {
                const originalOp = imageOps[k];
                const bbox = originalOp ? originalOp.bbox : [0, 0, 0, 0];
                const originalName = originalOp ? originalOp.name : returnedName;
                const imgTag = `<img src="${imageId}" alt="${originalName}" />\n`;
                images += imgTag;
                allItems.push({
                    type: 'image',
                    bbox: bbox,
                    page: i,
                    pageHeight: pageHeight,
                    pageWidth: pageWidth,
                    content: imgTag,
                    column: columnBoundary ? ((bbox[0] + bbox[2]) / 2 < columnBoundary ? 0 : 1) : 0,
                });
            });
        }

        for (let lineIdx = 0; lineIdx < sortedLines.length; lineIdx++) {
            if (tableLineSet.has(lineIdx)) {
                if (tableStartMap.has(lineIdx)) {
                    const tableDef = tableStartMap.get(lineIdx);
                    const tableLines = tableDef.indices.map(idx => sortedLines[idx]);
                    const tableHtml = formatTableHtml(tableLines, tableDef.boundaries);
                    currentChunk += tableHtml;
                    allItems.push({
                        type: 'text',
                        bbox: tableLines[0][1][0].bbox,
                        page: i,
                        pageHeight: pageHeight,
                        pageWidth: pageWidth,
                        content: tableHtml,
                        role: 'table',
                        column: tableLines[0][1][0].column ?? 0,
                    });
                }
                continue;
            }

            const [, lineItems] = sortedLines[lineIdx];
            const lineText = lineItems.map(item => item.text).join(' ');
            const avgFont = lineItems.reduce((sum, item) => sum + item.fontSize, 0) / lineItems.length;
            const role = isHeaderText(lineText, avgFont) ? 'header' : 'body';
            const block = constructBlock(lineText, role);

            currentChunk += block;

            allItems.push({
                type: 'text',
                bbox: lineItems[0].bbox,
                page: i,
                pageHeight: pageHeight,
                pageWidth: pageWidth,
                content: block,
                role: role,
                column: lineItems[0].column ?? 0,
            });
        }

        if (isEmbedding) {
            currentChunk += `\n\n`;
            chunks.push(currentChunk);
            currentChunk = '';
        }
    }
    if(!isEmbedding) {
        const filteredItems = sortAndFilterItems(allItems);
        const blocks = mergeBlocks(filteredItems);
        chunks = chunkBlocks(blocks, images);
    }
    return chunks;
}

function sortAndFilterItems(allItems) {
    allItems = allItems.filter(b => {
        if (!b.bbox) return false;
        const [x1, y1, x2, y2] = b.bbox;

        if ([x1, y1, x2, y2].some(v => !Number.isFinite(v) || v < 0)) return false;

        const width = x2 - x1;
        const height = y2 - y1;

        if (width > (b.pageWidth || 1000) * 2) return false;
        return height <= (b.pageHeight || 1000) * 2;
    });

    allItems.sort((a, b) => {
        if (a.page !== b.page) return a.page - b.page;

        const aCol = a.column ?? 0;
        const bCol = b.column ?? 0;
        if (aCol !== bCol) return aCol - bCol;

        const ay = a.bbox?.[1] ?? 0;
        const by = b.bbox?.[1] ?? 0;

        if (Math.abs(ay - by) > 1) return by - ay;

        const ax = a.bbox?.[0] ?? 0;
        const bx = b.bbox?.[0] ?? 0;
        return ax - bx;
    });

    return  filterOutFootersAndHeaders(allItems);
}

function mergeBlocks(items) {
    const blocks = [];
    let i = 0;
    while (i < items.length) {
        const item = items[i];

        if (item.type === 'text' && item.role === 'header') {
            blocks.push({
                role: 'header',
                content: item.content,
            });
            i++;
            continue;
        }

        if (item.type === 'text' && item.role === 'table') {
            blocks.push({
                role: 'table',
                content: item.content,
            });
            i++;
            continue;
        }

        if (item.type === 'text') {
            let currentY = item.bbox[1];
            let groupText = item.content;
            i++;

            while (i < items.length && items[i].type === 'text') {
                const next = items[i];
                if (next.role === 'header' || next.role === 'table') break;

                const nextY = next.bbox[1];

                if (Math.abs(nextY - currentY) < 5) {
                    groupText += ' ' + next.content;
                } else {
                    groupText += '\n' + next.content;
                }

                currentY = nextY;
                i++;
            }

            blocks.push({
                role: 'body',
                content: groupText,
            });
            continue;
        }

        if (item.type === 'image') {
            blocks.push({
                role: 'image',
                content: item.content,
            });
            i++;
        }
    }
    return blocks;
}

function chunkBlocks(blocks, allImagesString) {
    const chunks = [];
    let currentBuffer = [];
    let currentSize = 0;

    for (const block of blocks) {
        const blockSize = block.content.length;

        if (currentSize + blockSize > MAX_CHUNK_LENGTH) {
            let propagatedHeader = null;

            const lastItem = currentBuffer[currentBuffer.length - 1];

            if (lastItem && lastItem.role === 'header' && lastItem.content.length < MAX_CHUNK_LENGTH) {
                propagatedHeader = currentBuffer.pop();
            }

            if (currentBuffer.length > 0) {
                chunks.push(currentBuffer.map(b => b.content).join('\n'));
            }

            currentBuffer = [];
            currentSize = 0;

            if (propagatedHeader) {
                currentBuffer.push(propagatedHeader);
                currentSize += propagatedHeader.content.length;
            }
        }

        currentBuffer.push(block);
        currentSize += blockSize;
    }

    if (currentBuffer.length > 0) {
        chunks.push(currentBuffer.map(b => b.content).join('\n'));
    }

    if (allImagesString && allImagesString.length > 0) {
        chunks.push(allImagesString);
    }
    return chunks;
}
function filterOutFootersAndHeaders(blocks) {
    const freq = new Map();

    const normalize = (str) =>
        str
            .replace(/\d+/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

    for (const b of blocks) {
        if (b.type !== 'text') continue;
        if (b.content.length < 3) continue;

        const n = normalize(b.content);
        if (!freq.has(n)) freq.set(n, new Set());
        freq.get(n).add(b.page);
    }

    return blocks.filter(b => {
        if (b.type !== 'text') return true;

        const n = normalize(b.content);
        const pages = freq.get(n) || new Set();

        const appearsManyTimes = pages.size >= 2;

        const y = b.bbox[1];
        const pageHeight = b.pageHeight;

        const isHeaderBand = y > pageHeight * 0.85;
        const isFooterBand = y < pageHeight * 0.15;

        return !(appearsManyTimes && (isHeaderBand || isFooterBand));
    });
}

function isHeaderText(str, fontSize) {
    if (!str) return false;

    if (/^\s*\d+(\.\d+)+\s+.+/.test(str)) return true;

    if (/^\s*\d+\.\s+.+/.test(str)) return true;

    return fontSize > 15;
}

export function constructBlock(lineText, role) {
    if (role === 'header')
        return `<h1>${lineText}</h1>`;
    else
        return `<p>${lineText}</p>`;
}

const detectColumnBoundary = (rawItems, pageWidth) => {
    if (rawItems.length < 10) return null;

    const yGroups = new Map();
    for (const item of rawItems) {
        const ry = Math.round(item.y / 2) * 2;
        if (!yGroups.has(ry)) yGroups.set(ry, []);
        yGroups.get(ry).push(item);
    }

    const lineStarts = [];
    for (const [, items] of yGroups) {
        const sorted = [...items].sort((a, b) => a.bbox[0] - b.bbox[0]);
        lineStarts.push(sorted[0].bbox[0]);
        for (let j = 1; j < sorted.length; j++) {
            const prevRight = sorted[j - 1].bbox[2] || sorted[j - 1].bbox[0] + 20;
            if (sorted[j].bbox[0] - prevRight > 15) {
                lineStarts.push(sorted[j].bbox[0]);
            }
        }
    }

    if (lineStarts.length < 10) return null;

    const binSize = 30;
    const bins = new Map();
    for (const x of lineStarts) {
        const bin = Math.round(x / binSize) * binSize;
        bins.set(bin, (bins.get(bin) || 0) + 1);
    }

    const sortedBins = [...bins.entries()].sort((a, b) => b[1] - a[1]);
    const peak1Bin = sortedBins[0][0];
    const peak1Count = sortedBins[0][1];
    let peak2Bin = null;
    let peak2Count = 0;

    for (let i = 1; i < sortedBins.length; i++) {
        if (Math.abs(sortedBins[i][0] - peak1Bin) > pageWidth * 0.2) {
            peak2Bin = sortedBins[i][0];
            peak2Count = sortedBins[i][1];
            break;
        }
    }

    if (peak2Bin === null || peak1Count < 5 || peak2Count < 5) return null;

    const [leftPeak, rightPeak] = peak1Bin < peak2Bin ? [peak1Bin, peak2Bin] : [peak2Bin, peak1Bin];
    const rightPeakCount = peak1Bin < peak2Bin ? peak2Count : peak1Count;

    for (const [bin, count] of sortedBins) {
        if (Math.abs(bin - leftPeak) <= binSize * 2 || Math.abs(bin - rightPeak) <= binSize * 2) continue;
        if (count > rightPeakCount * 0.3) return null;
    }

    const fineBins = new Map();
    for (const x of lineStarts) {
        if (x >= rightPeak - binSize * 1.5 && x <= rightPeak + binSize * 1.5) {
            const fb = Math.round(x / 5) * 5;
            fineBins.set(fb, (fineBins.get(fb) || 0) + 1);
        }
    }
    const boundary = [...fineBins.entries()].sort((a, b) => b[1] - a[1])[0][0];

    const leftItems = rawItems.filter(item => (item.bbox[0] + (item.bbox[2] || item.bbox[0])) / 2 < boundary);
    const rightItems = rawItems.filter(item => (item.bbox[0] + (item.bbox[2] || item.bbox[0])) / 2 >= boundary);

    if (leftItems.length < 10 || rightItems.length < 10) return null;

    const leftAvgLen = leftItems.reduce((s, i) => s + i.text.length, 0) / leftItems.length;
    const rightAvgLen = rightItems.reduce((s, i) => s + i.text.length, 0) / rightItems.length;
    if (leftAvgLen < 6 || rightAvgLen < 6) return null;

    const getLineDensity = (items) => {
        const uniqueYs = [...new Set(items.map(i => Math.round(i.y)))].sort((a, b) => a - b);
        if (uniqueYs.length < 2) return 0;
        const span = uniqueYs[uniqueYs.length - 1] - uniqueYs[0];
        return span > 0 ? uniqueYs.length / span : 0;
    };
    if (getLineDensity(leftItems) < 0.03 || getLineDensity(rightItems) < 0.03) return null;

    return boundary;
};

const groupIntoLines = (rawItems) => {
    const lineMap = new Map();

    for (const item of rawItems) {
        const roundedY = Math.round(item.y);

        if (!lineMap.has(roundedY)) lineMap.set(roundedY, []);
        const line = lineMap.get(roundedY);

        if (item.text.length <= 2 && line.length) {
            const textToAppend = item.text[0] === ' ' ? item.text : item.text.slice(1);
            line[line.length - 1].text += textToAppend;
        } else {
            line.push(item);
        }
    }

    return Array.from(lineMap.entries())
        .sort((a, b) => b[0] - a[0])
        .map(([y, items]) => {
            const cleanedItems = items.map(obj => {
                obj.text = obj.text.replace(/(\.\s*){2,}/g, '');
                obj.text = obj.text.replace(/\s{2,}/g, ' ').trim();
                return obj;
            });
            return [y, cleanedItems];
        });
};

const applyStepNumbers = (sortedLines) => {
    const potentialSteps = [];
    sortedLines.forEach((lineData, lineIndex) => {
        const items = lineData[1];
        if (items.length > 1) {
            const firstItem = items[0];
            const text = firstItem.text.trim();

            if (/^\d+$/.test(text)) {
                potentialSteps.push({
                    lineIndex,
                    item: firstItem,
                    x: firstItem.bbox[0],
                });
            }
        }
    });

    const tolerance = 2.0;
    const cols = [];
    potentialSteps.forEach(step => {
        const col = cols.find(c => Math.abs(c.x - step.x) <= tolerance);
        if (col) {
            col.items.push(step);
        } else {
            cols.push({ x: step.x, items: [step] });
        }
    });

    cols.forEach(col => {
        if (col.items.length >= 2) {
            col.items.forEach(({ item }) => {
                item.text = `${item.text.trim()}.`;
            });
        }
    });
};

const MIN_CELL_GAP = 10;
const MIN_TABLE_GAP = 20;
const GAP_TOLERANCE = 40;

const getLineGapPositions = (items) => {
    if (items.length < 2) return [];
    const sorted = [...items].sort((a, b) => a.bbox[0] - b.bbox[0]);
    const positions = [];
    for (let j = 1; j < sorted.length; j++) {
        const prevRight = sorted[j - 1].bbox[2] || sorted[j - 1].bbox[0] + 20;
        const gap = sorted[j].bbox[0] - prevRight;
        if (gap >= MIN_TABLE_GAP) {
            positions.push(sorted[j].bbox[0]);
        }
    }
    return positions;
};

const detectTableRegions = (sortedLines) => {
    const lineGaps = sortedLines.map(([, items]) => getLineGapPositions(items));

    const regions = [];
    let currentRegion = [];
    let refX = null;
    let nonMatchStreak = 0;

    const finishRegion = () => {
        if (currentRegion.length >= 3) {
            regions.push([...currentRegion]);
        }
        currentRegion = [];
        refX = null;
        nonMatchStreak = 0;
    };

    for (let idx = 0; idx < sortedLines.length; idx++) {
        const gaps = lineGaps[idx];

        if (gaps.length === 0) {
            nonMatchStreak++;
            if (nonMatchStreak > 2 || currentRegion.length === 0) {
                finishRegion();
            }
            continue;
        }

        if (refX === null) {
            refX = gaps[0];
            currentRegion = [idx];
            nonMatchStreak = 0;
        } else if (gaps.some(x => Math.abs(x - refX) <= GAP_TOLERANCE)) {
            currentRegion.push(idx);
            nonMatchStreak = 0;
        } else {
            finishRegion();
            refX = gaps[0];
            currentRegion = [idx];
        }
    }
    finishRegion();

    for (const region of regions) {
        const first = region[0];
        const last = region[region.length - 1];
        region.length = 0;
        for (let i = first; i <= last; i++) {
            region.push(i);
        }
    }

    if (regions.length < 2) return regions;

    const merged = [regions[0]];
    for (let i = 1; i < regions.length; i++) {
        const prev = merged[merged.length - 1];
        const curr = regions[i];
        const prevEnd = prev[prev.length - 1];
        const currStart = curr[0];
        if (currStart - prevEnd <= 6) {
            for (let j = prevEnd + 1; j < currStart; j++) {
                prev.push(j);
            }
            prev.push(...curr);
        } else {
            merged.push(curr);
        }
    }

    return merged;
};

const clusterIntoCells = (sortedItems) => {
    const cells = [[sortedItems[0]]];
    for (let j = 1; j < sortedItems.length; j++) {
        const prevRight = sortedItems[j - 1].bbox[2] || sortedItems[j - 1].bbox[0] + 20;
        const gap = sortedItems[j].bbox[0] - prevRight;
        if (gap > MIN_CELL_GAP) {
            cells.push([sortedItems[j]]);
        } else {
            cells[cells.length - 1].push(sortedItems[j]);
        }
    }
    return cells;
};

const getColumnBoundaries = (tableLines) => {
    const allGapPositions = [];
    for (const [, items] of tableLines) {
        allGapPositions.push(...getLineGapPositions(items));
    }
    if (allGapPositions.length === 0) return [];

    allGapPositions.sort((a, b) => a - b);
    const boundaries = [];
    let i = 0;
    while (i < allGapPositions.length) {
        const cluster = [allGapPositions[i]];
        let j = i + 1;
        while (j < allGapPositions.length && allGapPositions[j] - allGapPositions[i] < GAP_TOLERANCE) {
            cluster.push(allGapPositions[j]);
            j++;
        }
        if (cluster.length >= Math.max(3, tableLines.length * 0.3)) {
            boundaries.push(Math.min(...cluster) - 10);
        }
        i = j;
    }
    return boundaries;
};

const extractPageLines = async (page) => {
    const opList = await page.getOperatorList();
    const { fnArray, argsArray } = opList;
    let tStack = [];
    let ctm = [1, 0, 0, 1, 0, 0];
    let pending = [];
    const segments = [];

    const xform = (x, y) => [
        ctm[0] * x + ctm[2] * y + ctm[4],
        ctm[1] * x + ctm[3] * y + ctm[5],
    ];

    for (let i = 0; i < fnArray.length; i++) {
        const fn = fnArray[i];
        if (fn === OPS.save) tStack.push([...ctm]);
        else if (fn === OPS.restore && tStack.length) ctm = tStack.pop();
        else if (fn === OPS.transform) ctm = multiply(ctm, argsArray[i]);
        else if (fn === OPS.constructPath) pending = buildPathSegments(argsArray[i][0], argsArray[i][1], xform);
        else if (fn === OPS.stroke || fn === OPS.closeStroke || fn === OPS.fillStroke || fn === OPS.eoFillStroke) {
            segments.push(...pending);
            pending = [];
        } else if (fn === OPS.fill || fn === OPS.eoFill) {
            segments.push(...pending.filter(s => s.isRect));
            pending = [];
        }
    }
    return segments;
};

const buildRectSegments = (segs, coords, ci, xform) => {
    const [x1, y1] = xform(coords[ci], coords[ci + 1]);
    const [x2, y2] = xform(coords[ci] + coords[ci + 2], coords[ci + 1] + coords[ci + 3]);
    const left = Math.min(x1, x2), right = Math.max(x1, x2);
    const bottom = Math.min(y1, y2), top = Math.max(y1, y2);
    const w = right - left, h = top - bottom;

    if (h < 3 && w > 15) {
        segs.push({ x1: left, y1: (bottom + top) / 2, x2: right, y2: (bottom + top) / 2, isRect: true });
    } else if (w < 3 && h > 15) {
        segs.push({ x1: (left + right) / 2, y1: bottom, x2: (left + right) / 2, y2: top, isRect: true });
    }
};

const buildPathSegments = (ops, coords, xform) => {
    const segs = [];
    let ci = 0, px = 0, py = 0, sx = 0, sy = 0;

    for (const op of ops) {
        if (op === OPS.moveTo) {
            [px, py] = xform(coords[ci], coords[ci + 1]);
            sx = px; sy = py;
            ci += 2;
        } else if (op === OPS.lineTo) {
            const [nx, ny] = xform(coords[ci], coords[ci + 1]);
            segs.push({ x1: px, y1: py, x2: nx, y2: ny, isRect: false });
            px = nx; py = ny;
            ci += 2;
        } else if (op === OPS.curveTo) {
            [px, py] = xform(coords[ci + 4], coords[ci + 5]);
            ci += 6;
        } else if (op === OPS.curveTo2) {
            [px, py] = xform(coords[ci + 2], coords[ci + 3]);
            ci += 4;
        } else if (op === OPS.curveTo3) {
            [px, py] = xform(coords[ci], coords[ci + 1]);
            ci += 2;
        } else if (op === OPS.closePath) {
            if (Math.abs(px - sx) > 0.5 || Math.abs(py - sy) > 0.5) {
                segs.push({ x1: px, y1: py, x2: sx, y2: sy, isRect: false });
            }
            px = sx; py = sy;
        } else if (op === OPS.rectangle) {
            buildRectSegments(segs, coords, ci, xform);
            ci += 4;
        }
    }
    return segs;
};

const clusterLinesByPosition = (lines, key, tolerance) => {
    const sorted = [...lines].sort((a, b) => a[key] - b[key]);
    const clusters = [];
    let group = [sorted[0]];

    for (let i = 1; i < sorted.length; i++) {
        if (sorted[i][key] - group[0][key] < tolerance) {
            group.push(sorted[i]);
        } else {
            clusters.push(group);
            group = [sorted[i]];
        }
    }
    clusters.push(group);
    return clusters;
};

const groupClustersIntoGrids = (clusters) => {
    const colInfo = clusters.map(c => ({
        x: c.reduce((s, l) => s + l.x, 0) / c.length,
        y1: Math.min(...c.map(l => l.y1)),
        y2: Math.max(...c.map(l => l.y2)),
    }));

    const grids = [];
    const used = new Set();

    for (let i = 0; i < colInfo.length; i++) {
        if (used.has(i)) continue;
        const group = [i];
        used.add(i);
        for (let j = i + 1; j < colInfo.length; j++) {
            if (used.has(j)) continue;
            const overlap = Math.min(colInfo[i].y2, colInfo[j].y2) - Math.max(colInfo[i].y1, colInfo[j].y1);
            const minSpan = Math.min(colInfo[i].y2 - colInfo[i].y1, colInfo[j].y2 - colInfo[j].y1);
            if (minSpan > 0 && overlap / minSpan > 0.5) {
                group.push(j);
                used.add(j);
            }
        }
        if (group.length >= 2) {
            const cols = group.map(g => colInfo[g]);
            grids.push({
                y1: Math.min(...cols.map(c => c.y1)),
                y2: Math.max(...cols.map(c => c.y2)),
                boundaries: cols.map(c => c.x).sort((a, b) => a - b),
            });
        }
    }
    return grids;
};

const findLineGrids = (segments, pageWidth, pageHeight) => {
    const vLines = [];
    const hLines = [];
    for (const seg of segments) {
        const dx = Math.abs(seg.x2 - seg.x1);
        const dy = Math.abs(seg.y2 - seg.y1);
        const midX = (seg.x1 + seg.x2) / 2;
        const midY = (seg.y1 + seg.y2) / 2;
        if (midX < 0 || midX > pageWidth || midY < 0 || midY > pageHeight) continue;
        if (dx < 3 && dy >= 20) {
            vLines.push({ x: midX, y1: Math.min(seg.y1, seg.y2), y2: Math.max(seg.y1, seg.y2) });
        }
        if (dy < 3 && dx >= 20) {
            hLines.push({ y: midY, x1: Math.min(seg.x1, seg.x2), x2: Math.max(seg.x1, seg.x2) });
        }
    }
    if (vLines.length < 2) return [];
    const clusters = clusterLinesByPosition(vLines, 'x', 5);
    if (clusters.length < 2) return [];
    const grids = groupClustersIntoGrids(clusters);

    return grids.filter(grid => {
        const gridLeft = Math.min(...grid.boundaries);
        const gridRight = Math.max(...grid.boundaries);
        const gridWidth = gridRight - gridLeft;
        if (gridWidth < 10) return false;
        const confirming = hLines.filter(h => {
            if (h.y < grid.y1 - 5 || h.y > grid.y2 + 5) return false;
            const overlap = Math.min(h.x2, gridRight) - Math.max(h.x1, gridLeft);
            return overlap >= gridWidth * 0.5;
        });
        return confirming.length >= 2;
    });
};

const buildTableDefs = async (page, sortedLines) => {
    const segments = await extractPageLines(page);
    const viewport = page.getViewport({ scale: 1 });
    const grids = findLineGrids(segments, viewport.width, viewport.height);
    const defs = [];
    const covered = new Set();

    for (const grid of grids) {
        const indices = [];
        for (let idx = 0; idx < sortedLines.length; idx++) {
            const [y] = sortedLines[idx];
            if (y >= grid.y1 - 5 && y <= grid.y2 + 5) {
                indices.push(idx);
                covered.add(idx);
            }
        }
        if (indices.length >= 2) {
            const bounds = grid.boundaries.length > 2 ? grid.boundaries.slice(1, -1) : null;
            defs.push({ indices, boundaries: bounds });
        }
    }

    const gapRegions = detectTableRegions(sortedLines);
    for (const region of gapRegions) {
        const uncovered = region.filter(idx => !covered.has(idx));
        if (uncovered.length >= 3) {
            defs.push({ indices: uncovered, boundaries: null });
        }
    }

    return defs;
};

const isTitleRow = (sorted, boundaries) => {
    if (boundaries.length === 0) return false;
    const allStartInFirstCol = sorted.every(item => item.bbox[0] < boundaries[0]);
    if (!allStartInFirstCol) return false;
    const rightEdge = Math.max(...sorted.map(item => item.bbox[2]));
    return rightEdge >= boundaries[0];
};

const formatTableHtml = (tableLines, precomputedBoundaries) => {
    const boundaries = precomputedBoundaries || getColumnBoundaries(tableLines);
    let html = '';
    let inTable = false;

    for (const [, items] of tableLines) {
        const sorted = [...items].sort((a, b) => a.bbox[0] - b.bbox[0]);

        if (isTitleRow(sorted, boundaries)) {
            if (inTable) {
                html += '</table>';
                inTable = false;
            }
            html += `<p>${sorted.map(c => c.text).join(' ')}</p>`;
            continue;
        }

        if (!inTable) {
            html += '<table>';
            inTable = true;
        }

        html += '<tr>';
        if (boundaries.length > 0) {
            for (let col = 0; col <= boundaries.length; col++) {
                const lower = col === 0 ? -Infinity : boundaries[col - 1];
                const upper = col === boundaries.length ? Infinity : boundaries[col];
                const cellItems = sorted.filter(item => item.bbox[0] >= lower && item.bbox[0] < upper);
                html += `<td>${cellItems.map(c => c.text).join(' ')}</td>`;
            }
        } else {
            const cells = clusterIntoCells(sorted);
            for (const cell of cells) {
                html += `<td>${cell.map(c => c.text).join(' ')}</td>`;
            }
        }
        html += '</tr>';
    }

    if (inTable) html += '</table>';
    return html;
};

export async function getPageData(page, pageWidth) {
    const textContent = await page.getTextContent();
    const rawItems = [];

    for (const item of textContent.items) {
        let text = item.str.trim();
        if (!text) continue;

        const [a, b, , , x, y] = item.transform;
        const fontSize = Math.hypot(a, b);

        rawItems.push({
            text,
            fontSize,
            x,
            y,
            bbox: [x, y - fontSize, x + item.width, y],
        });
    }

    const columnBoundary = pageWidth ? detectColumnBoundary(rawItems, pageWidth) : null;

    if (columnBoundary) {
        const leftItems = rawItems.filter(
            item => (item.bbox[0] + (item.bbox[2] || item.bbox[0])) / 2 < columnBoundary
        );
        const rightItems = rawItems.filter(
            item => (item.bbox[0] + (item.bbox[2] || item.bbox[0])) / 2 >= columnBoundary
        );

        const leftLines = groupIntoLines(leftItems);
        const rightLines = groupIntoLines(rightItems);

        leftLines.forEach(([, lineItems]) => lineItems.forEach(it => { it.column = 0; }));
        rightLines.forEach(([, lineItems]) => lineItems.forEach(it => { it.column = 1; }));

        applyStepNumbers(leftLines);
        applyStepNumbers(rightLines);

        return { lines: [...leftLines, ...rightLines], columnBoundary };
    }

    const sortedLines = groupIntoLines(rawItems);
    applyStepNumbers(sortedLines);

    return { lines: sortedLines, columnBoundary: null };
}

function multiply(m1, m2) {
    return [
        m1[0] * m2[0] + m1[2] * m2[1],
        m1[1] * m2[0] + m1[3] * m2[1],
        m1[0] * m2[2] + m1[2] * m2[3],
        m1[1] * m2[2] + m1[3] * m2[3],
        m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
        m1[1] * m2[4] + m1[3] * m2[5] + m1[5],
    ];
}

function getBBox(matrix) {
    const x0 = 0, y0 = 0;
    const x1 = 1, y1 = 0;
    const x2 = 1, y2 = 1;
    const x3 = 0, y3 = 1;

    const transformPoint = (x, y, m) => {
        return {
            x: m[0] * x + m[2] * y + m[4],
            y: m[1] * x + m[3] * y + m[5]
        };
    };

    const p0 = transformPoint(x0, y0, matrix);
    const p1 = transformPoint(x1, y1, matrix);
    const p2 = transformPoint(x2, y2, matrix);
    const p3 = transformPoint(x3, y3, matrix);

    const xs = [p0.x, p1.x, p2.x, p3.x];
    const ys = [p0.y, p1.y, p2.y, p3.y];

    return [
        Math.min(...xs),
        Math.min(...ys),
        Math.max(...xs),
        Math.max(...ys)
    ];
}

export async function getPageImages(page) {
    const opList = await page.getOperatorList();
    const imageItems = [];

    let transformStack = [];
    let currentTransform = [1, 0, 0, 1, 0, 0];

    const fnArray = opList.fnArray;
    const argsArray = opList.argsArray;

    for (let i = 0; i < fnArray.length; i++) {
        const fn = fnArray[i];
        const args = argsArray[i];

        if (fn === OPS.save) {
            transformStack.push([...currentTransform]);
        }
        else if (fn === OPS.restore) {
            if (transformStack.length > 0) {
                currentTransform = transformStack.pop();
            }
        }
        else if (fn === OPS.transform) {
            currentTransform = multiply(currentTransform, args);
        }
        else if (fn === OPS.paintImageXObject || fn === OPS.paintInlineImageXObject) {
            const imageName = args[0];
            const bbox = getBBox(currentTransform);

            imageItems.push({
                name: imageName,
                type: 'image',
                bbox: bbox
            });
        }
    }
    return imageItems;
}


export async function getImageDataFromResources(page, imageName) {
    try {

        const pageDict = page.pageDict || page._pageDict;
        if (!pageDict) {
            return null;
        }

        const resources = pageDict.get('Resources');
        if (!resources) {
            return null;
        }

        const xObjects = resources.get('XObject');
        if (!xObjects || !xObjects.has(imageName)) {
            return null;
        }

        const imageRef = xObjects.get(imageName);


        const subtype = imageRef.get('Subtype');
        if (!subtype || subtype.name !== 'Image') {
            return null;
        }


        const width = imageRef.get('Width');
        const height = imageRef.get('Height');
        const colorSpace = imageRef.get('ColorSpace');
        const bitsPerComponent = imageRef.get('BitsPerComponent') || 8;


        let kind = 2;
        let channels = 3;

        if (colorSpace) {
            if (colorSpace.name === 'DeviceGray') {
                kind = 1;
                channels = 1;
            } else if (colorSpace.name === 'DeviceRGB') {
                kind = 2;
                channels = 3;
            } else if (colorSpace.name === 'DeviceCMYK') {
                kind = 4;
                channels = 4;
            }
        }


        let imageData = null;
        if (imageRef.getStreamData) {
            try {
                imageData = await imageRef.getStreamData();
            } catch (error) {
            }
        }

        if (!imageData) {
            const objData = await new Promise(resolve => {
                page.objs.get(imageName, resolve);
            });

            if (objData && objData.data) {
                imageData = objData.data;
                kind = objData.kind || kind;
            }
        }

        if (!imageData) {
            return null;
        }

        return {
            data: imageData,
            width: width,
            height: height,
            kind: kind,
            channels: channels,
            bitsPerComponent: bitsPerComponent
        };

    } catch (error) {
        return null;
    }
}


export function convertImageDataToCanvas(imgData) {
    if (!imgData || !imgData.data) {
        return null;
    }

    const canvas = document.createElement('canvas');
    canvas.width = imgData.width;
    canvas.height = imgData.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas context not available');

    const imageData = ctx.createImageData(imgData.width, imgData.height);
    const rgbaData = imageData.data;


    switch (imgData.kind) {
        case 1: // Grayscale
            for (let i = 0, k = 0; i < imgData.data.length; i++, k += 4) {
                const v = imgData.data[i];
                rgbaData[k] = v;     // R
                rgbaData[k + 1] = v; // G
                rgbaData[k + 2] = v; // B
                rgbaData[k + 3] = 255; // A
            }
            break;
        case 2: // RGB
            for (let i = 0, k = 0; i < imgData.data.length; i += 3, k += 4) {
                rgbaData[k] = imgData.data[i];     // R
                rgbaData[k + 1] = imgData.data[i + 1]; // G
                rgbaData[k + 2] = imgData.data[i + 2]; // B
                rgbaData[k + 3] = 255; // A
            }
            break;
        case 3: // RGBA
            rgbaData.set(imgData.data);
            break;
        case 4: // CMYK
            for (let i = 0, k = 0; i < imgData.data.length; i += 4, k += 4) {
                const c = imgData.data[i] / 255;
                const m = imgData.data[i + 1] / 255;
                const y = imgData.data[i + 2] / 255;
                const kK = imgData.data[i + 3] / 255;
                rgbaData[k] = 255 * (1 - c) * (1 - kK);     // R
                rgbaData[k + 1] = 255 * (1 - m) * (1 - kK); // G
                rgbaData[k + 2] = 255 * (1 - y) * (1 - kK); // B
                rgbaData[k + 3] = 255; // A
            }
            break;
        default:
            if (imgData.data.length === rgbaData.length) {
                rgbaData.set(imgData.data);
            } else {
                return null;
            }
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
}



export async function extractPageImages(page, imageIds, scale = 2, file, sizeOptions = {}) {
    const opList = await page.getOperatorList();
    const imagesIdMap = [];
    let imageIndex = 0;

    for (let j = 0; j < opList.fnArray.length; j++) {
        if ( (opList.fnArray[j] === pdfjs.OPS.paintImageXObject ||
                opList.fnArray[j] === pdfjs.OPS.paintInlineImageXObject) &&
            imageIds.includes(opList.argsArray[j][0])) {
            const imageName = opList.argsArray[j][0];

            const canvas = await tryExtractImageCanvas(page, imageName, scale, sizeOptions);
            if (!canvas) {
                continue;
            }

            const imageResult = await saveCanvasAsImage(canvas, file, imageIndex);
            if (imageResult) {
                imagesIdMap.push(imageResult);
                imageIndex++;
            }
        }
    }

    return imagesIdMap;
}

async function tryExtractImageCanvas(page, imageName, scale, sizeOptions) {
    let canvas = await tryMethod1(page, imageName, sizeOptions);
    if (canvas) return canvas;

    canvas = await tryMethod2(page, imageName, sizeOptions);
    if (canvas) return canvas;

    canvas = await tryMethod3(page, imageName, scale, sizeOptions);
    return canvas;
}

async function tryMethod1(page, imageName, sizeOptions) {
    try {
        const imgData = await getImageDataFromResources(page, imageName);
        if (imgData && imgData.data) {
            if (!isImageSizeValid(imgData.width, imgData.height, sizeOptions)) {
                return null;
            }
            return convertImageDataToCanvas(imgData);
        }
    } catch (error) {
    }
    return null;
}

async function tryMethod2(page, imageName, sizeOptions) {
    try {
        const originalImgData = await new Promise(resolve =>
            page.objs.get(imageName, resolve)
        );

        if (originalImgData && originalImgData.data) {
            if (!isImageSizeValid(originalImgData.width, originalImgData.height, sizeOptions)) {
                return null;
            }
            return convertImageDataToCanvas(originalImgData);
        }
    } catch (error) {
    }
    return null;
}

async function tryMethod3(page, imageName, scale, sizeOptions) {
    try {
        const canvas = await extractImageViaPageRender(page, scale);

        if (canvas && isImageSizeValid(canvas.width, canvas.height, sizeOptions)) {
            return canvas;
        }
    } catch (error) {
    }
    return null;
}

async function saveCanvasAsImage(canvas, file, imageIndex) {
    try {
        const blob = await new Promise(resolve =>
            canvas.toBlob(b => resolve(b), 'image/png')
        );

        if (blob) {
            const imageId = await HtmlParsing.uploadImageFromFile(blob, file, imageIndex, 'png');
            const imageNameNew = `extracted_image_${file.name}_${imageIndex}_${imageId}.png`;
            return [imageNameNew, imageId];
        }
    } catch (error) {
    }
    return null;
}

function isImageSizeValid(width, height, options = {}) {
    const {
        minWidth = 64,
        minHeight = 64,

        aspectRatioMin = 0.1,
        aspectRatioMax = 10,
        hardMaxPixels = 20_000_000,


        maxWidth = 4096,
        maxHeight = 4096,
        maxArea = 4_000_000
    } = options;

    if (width < minWidth || height < minHeight) {
        return false;
    }

    const aspectRatio = width / height;
    if (aspectRatio < aspectRatioMin || aspectRatio > aspectRatioMax) {
        return false;
    }

    const area = width * height;

    if (area > hardMaxPixels) {
        return false;
    }

    if (
        width > maxWidth ||
        height > maxHeight ||
        area > maxArea
    ) {
        return 'resize';
    }

    return true;
}

const extractWithTimeout = async (page, imageOps, scale, file) => {
    return Promise.race([
        extractPageImages(page, imageOps, scale, file),
        new Promise((resolve) =>
            setTimeout(() => resolve([]), 10000)
        )
    ]);
};
export async function extractImageViaPageRender(page, scale = 2) {
    try {
        const viewport = page.getViewport({ scale: scale });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
            canvasContext: context,
            viewport: viewport
        };

        await page.render(renderContext).promise;
        return canvas;

    } catch (error) {
        return null;
    }
}

export function handleAbort(file, abortedFiles, isEmbedding){
    if (abortedFiles.has(file.name) || (abortedFiles.has('ABORT ALL') && isEmbedding)) {
        abortedFiles.delete(file.name);
        return true;
    }
    return false;
}
